// src/pages/components/TabelaMaquinas.jsx

import React from 'react';
import {
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
    IconButton, Tooltip, Chip, CircularProgress, Box
} from '@mui/material';
import { Edit as EditIcon, Delete as DeleteIcon } from '@mui/icons-material';
import { FormatarDinherio } from '../helpers/FormatarBrl';

const StatusChip = ({ status }) => {
    const statusConfig = {
        S: { label: 'Ativo', color: 'success' },
        N: { label: 'Inativo', color: 'error' },
    };

    const config = statusConfig[status] || { label: 'Não informado', color: 'default' };

    return <Chip label={config.label} color={config.color} size="small" />;
};

export default function TabelaProdutos({ produtos, onEdit, onDelete, loadingState }) {
    const { carregando, deletingId } = loadingState;


    if (carregando === 'fetching' || carregando === 'searching') {
        return <Box sx={{ display: 'flex', justifyContent: 'center', p: 5 }}><CircularProgress color="inherit" /></Box>
    }

    if (produtos.length === 0) {
        return <Box sx={{ textAlign: 'center', p: 5 }}>Nenhum produto encontrado.</Box>
    }

    return (
        <TableContainer>
            <Table sx={{ minWidth: 650 }} aria-label="tabela de máquinas">
                <TableHead>
                    <TableRow sx={{ '& th': { fontWeight: 'bold' } }}>
                        <TableCell>Valor</TableCell>
                        <TableCell>Nome produto</TableCell>
                        <TableCell>Grupo</TableCell>
                        <TableCell>Subgrupo</TableCell>
                        <TableCell align="center">Status</TableCell>
                        <TableCell align="center">Ações</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {produtos.map((prod) => (
                        <TableRow key={prod.id} hover>
                            <TableCell>{FormatarDinherio(prod.valor)}</TableCell>
                            <TableCell>{prod.nome}</TableCell>
                            <TableCell>{prod?.nome_do_grupo || "Não informado"}</TableCell>
                            <TableCell>{prod?.nome_do_subgrupo || "Não informado"}</TableCell>
                            <TableCell align="center">
                                <StatusChip status={prod.status} />
                            </TableCell>
                            <TableCell align="center">
                                <Tooltip title="Editar">
                                    <IconButton color="primary" onClick={() => onEdit(prod)}>
                                        <EditIcon />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title="Excluir">
                                    <IconButton color="error" onClick={() => onDelete(prod.cod_produto)} disabled={deletingId === prod.cod_produto}>
                                        {deletingId === prod.cod_produto ? <CircularProgress size={22} color="inherit" /> : <DeleteIcon />}
                                    </IconButton>
                                </Tooltip>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}